// extracted by mini-css-extract-plugin
export default {"fiord":"#475467","flamingo":"#f04438","hint":"styles_hint__3n78q","error":"styles_error__XeZRo"};